import {
  faArrowDownBigSmall,
  faArrowUpBigSmall,
  faPenNib,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { AskAiCommand } from '../../commands/types';

export const getRequestBlockTitle = (command: AskAiCommand) => {
  switch (command) {
    case AskAiCommand.EnhanceWithMyNotes:
      return (
        <FormattedMessage id="ask_ai_command_processor.request.enhance_with_notes.title" />
      );
    case AskAiCommand.MakeLonger:
      return (
        <FormattedMessage id="ask_ai_command_processor.request.make_longer.title" />
      );
    case AskAiCommand.MakeShorter:
      return (
        <FormattedMessage id="ask_ai_command_processor.request.make_shorter.title" />
      );
  }
};
export const getSectionTitleIcon = (command: AskAiCommand) => {
  switch (command) {
    case AskAiCommand.EnhanceWithMyNotes:
      return faPenNib;
    case AskAiCommand.MakeLonger:
      return faArrowUpBigSmall;
    case AskAiCommand.MakeShorter:
      return faArrowDownBigSmall;
  }
};
export const getSectionTitle = (command: AskAiCommand, isLoading: boolean) => {
  switch (command) {
    case AskAiCommand.EnhanceWithMyNotes:
      return isLoading ? (
        <FormattedMessage id="ask_ai_command_processor.request.enhance_with_notes.loading_section_title" />
      ) : (
        <FormattedMessage id="ask_ai_command_processor.request.enhance_with_notes.section_title" />
      );
    case AskAiCommand.MakeLonger:
      return isLoading ? (
        <FormattedMessage id="ask_ai_command_processor.request.make_longer.loading_section_title" />
      ) : (
        <FormattedMessage id="ask_ai_command_processor.request.make_longer.section_title" />
      );
    case AskAiCommand.MakeShorter:
      return isLoading ? (
        <FormattedMessage id="ask_ai_command_processor.request.make_shorter.loading_section_title" />
      ) : (
        <FormattedMessage id="ask_ai_command_processor.request.make_shorter.section_title" />
      );
  }
};
